import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpService } from 'app/shared/services/http.service';
import * as emiGlobals from 'app/globals';

@Injectable()
export class CalculatorService {

  private PropertyData = new BehaviorSubject('default');
  private inputData = new BehaviorSubject('default');
  private loanEligibility = new BehaviorSubject('default');
  private productDetails = new BehaviorSubject('default');
  currentValues = this.PropertyData.asObservable();
  currentData = this.inputData.asObservable();
  currentLoanEligibility = this.loanEligibility.asObservable();
  currentproductDetails = this.productDetails.asObservable();


  categoryList: any;
  productList: any;
  SearchCategory: any;
  noOffer: any;
  activeProduct: any;
  activeStatus: any;
  offer: any;
  defaultOffer: boolean;
  inputValues: any;

  loading = false;

  getCurrentData(data: any) {
    this.PropertyData.next(data);
  }
  getInputData(data: any) {
    this.inputData.next(data);
  }
  getLoanEligibilty(data: any) {
    this.loanEligibility.next(data);
  }
  getProductDetails(data: any) {
  this.productDetails.next(data);
  }

  clearCurrentData() {
    this.PropertyData.next('default');
  }
 
  constructor(public httpService: HttpService) { }
  // getAllProductCategory() {
  //   this.httpService.getAll(emiGlobals.productCategoryUrl).subscribe(result => {
  //     this.categoryList = result;
  //     this.categoryList.forEach(element => {
  //       const categoryId = localStorage.getItem('categoryId');
  //       if ((element.id) === JSON.parse(categoryId)) {
  //         this.productList = element.sub_product;
  //       }
  //     });
  //   });
  // }

 
}



// WEBPACK FOOTER //
// ./src/app/calculators/calculator.service.ts